
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { ILanguageInfo } from '@models';

import {
    Observable,
    ReplaySubject,
} from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    private _languages$: ReplaySubject<ILanguageInfo[]>;
    private _endpoint: string;
    private _hasSentRequest: boolean;

    constructor(
        private _http: HttpClient,
        private _appState: AppStateFacade,
    ) {
        this._endpoint = 'odata/Settings';
        this._hasSentRequest = false;
        this._languages$ = new ReplaySubject(1);
    }

    public getAll(): Observable<ILanguageInfo[]> {
        if (!this._hasSentRequest) {
            this._http.get(`${this._endpoint}/UiPath.Server.Configuration.OData.GetLanguages?v=
            ${this._appState.authConfig.buildVersion}`)
                .pipe(
                    map((result: any) => {
                        return result.Items;
                    }),
                )
                .subscribe(languages => {
                    this._languages$.next(languages);
                    this._languages$.complete();
                }, error => {
                    error.isSeed = true;
                    throw error;
                });
            this._hasSentRequest = true;
        }

        return this._languages$;
    }
}
